import React from 'react';
import { cn } from '../../../lib/utils';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../components/ui/alert-dialog';
import { Loader2 } from 'lucide-react';
import { DeleteUserDialogProps } from '../types';

export function DeleteUserDialog({
  isDark,
  user,
  isDeleting,
  onOpenChange,
  onConfirm,
}: DeleteUserDialogProps) {
  return (
    <AlertDialog open={!!user} onOpenChange={(open) => !open && onOpenChange(open)}>
      <AlertDialogContent className={isDark ? 'bg-[#1A1A22] border-slate-700' : ''}>
        <AlertDialogHeader>
          <AlertDialogTitle className={isDark ? 'text-white' : ''}>
            Удалить аккаунт {user?.email || `@${user?.username ?? ''}`}?
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className={cn('space-y-2 text-sm', isDark ? 'text-slate-400' : 'text-slate-500')}>
              <p>Пользователь будет разлогинен на всех устройствах и не сможет войти.</p>
              <p>Прогресс и подписка сохранятся в базе — аккаунт можно восстановить.</p>
              <p className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                Он не сможет зарегистрироваться заново с этим email — email останется занят.
              </p>
              {user?.isSubscribed && (
                <p className="rounded-lg bg-red-500/10 p-3 text-red-500">
                  У пользователя активная подписка. Удаление аккаунта не отменяет подписку
                  в App Store / Google Play — её должен отменить сам пользователь.
                </p>
              )}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            disabled={isDeleting}
            className={isDark ? 'border-slate-700 text-slate-300 hover:bg-slate-800' : ''}
          >
            Отмена
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isDeleting}
            className="bg-red-600 hover:bg-red-700"
          >
            {isDeleting && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Удалить
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
